// Formats a Stripe unit amount (integer cents) as a display currency string
export function formatCurrency(unitAmountCents) {
    const amount = (unitAmountCents || 0) / 100;
    return `$${amount.toFixed(2)}`;
}

// Checks whether a product's Stripe metadata.Frequency matches the selected donation frequency
export function matchesFrequency(product, frequency, {one_time, monthly, annually}) {
    const freqStr = (product.metadata?.Frequency || "").toLowerCase();
    if (frequency === one_time) return /one/.test(freqStr);
    if (frequency === monthly) return /mon/.test(freqStr);
    if (frequency === annually) return /ann/.test(freqStr);
    return false;
}
